class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day")
            .replace(/ /g, '')
            .split(",")
            .filter(d => d.length > 0);
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.targetTime = this.getAttribute("data-time");

        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');

        // Build a proper BCP 47 locale from the html lang attribute
        const htmlLang = document.documentElement.lang || 'pt-PT';
        this.locale = this.resolveLocale(htmlLang);

        // Always populate the delivery dates
        this.productDeliveryTime();

        // Calculate countdown - if today is an excluded day, countdown to next business day cutoff
        this.updateCountdown();

        // Show the element
        this.classList.remove('d-none');
        this.style.display = "block";

        setInterval(() => {
            this.updateCountdown();
        }, 1000);
    }

    updateCountdown() {
        const countdown = this.countdownToTime(this.targetTime);
        if (this.hr) this.hr.innerHTML = countdown.hours;
        if (this.mins) this.mins.innerHTML = countdown.minutes;
    }

    resolveLocale(lang) {
        const localeMap = {
            'pt': 'pt-PT',
            'pt-pt': 'pt-PT',
            'pt-br': 'pt-BR',
            'en': 'en-US',
            'es': 'es-ES',
            'fr': 'fr-FR',
            'de': 'de-DE',
            'it': 'it-IT',
            'nl': 'nl-NL',
            'da': 'da-DK',
            'sv': 'sv-SE',
            'nb': 'nb-NO',
            'fi': 'fi-FI',
            'pl': 'pl-PL',
            'cs': 'cs-CZ',
            'ro': 'ro-RO',
            'hu': 'hu-HU',
            'bg': 'bg-BG',
            'hr': 'hr-HR',
            'sk': 'sk-SK',
            'sl': 'sl-SI',
            'lt': 'lt-LT',
            'el': 'el-GR',
            'tr': 'tr-TR',
            'ru': 'ru-RU',
            'ja': 'ja-JP',
            'ko': 'ko-KR',
            'th': 'th-TH',
            'vi': 'vi-VN',
            'id': 'id-ID',
            'hi': 'hi-IN',
            'zh': 'zh-CN'
        };
        const key = lang.toLowerCase();
        return localeMap[key] || lang || 'pt-PT';
    }

    isDayExcluded(date) {
        const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        return this.excludedDays.includes(dayNames[date.getDay()]);
    }

    getNextBusinessDay(fromDate) {
        const date = new Date(fromDate);
        date.setDate(date.getDate() + 1);
        while (this.isDayExcluded(date)) {
            date.setDate(date.getDate() + 1);
        }
        return date;
    }

    productDeliveryTime() {
        const orderDlvr = document.querySelectorAll("[data-delivery-time]");
        if (orderDlvr.length === 0) return;

        let startDay = this.calculateDeliveryDate(this.numbDateStart);
        let endDay = this.calculateDeliveryDate(this.numbDateEnd);

        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);

        orderDlvr.forEach(el => {
            const startEl = el.querySelector('[data-start-delivery]');
            const endEl = el.querySelector('[data-end-delivery]');
            
            if (startEl) startEl.innerHTML = formattedStartDate;
            if (endEl) endEl.innerHTML = formattedEndDate;
        });
    }

    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = this.locale;
        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });

        // Capitalize first letter of day name
        const capitalizedDay = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

        // Get ordinal suffix for the day
        const dayNum = date.getDate();
        const ordinalSuffix = this.getOrdinalSuffix(dayNum);

        // Replace tokens - order matters: longer tokens first to avoid partial matches
        const formattedDate = formatString
            .replace('DDth', dayOfMonth + ordinalSuffix)
            .replace('YYYY', year)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('DD', dayOfMonth)
            .replace('d', capitalizedDay);

        return formattedDate;
    }

    getOrdinalSuffix(day) {
        if (this.locale.startsWith('pt')) {
            return 'º';
        }
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    calculateDeliveryDate(businessDaysToAdd) {
        const now = new Date();
        const deliveryDate = new Date(now);
        let daysAdded = 0;
        const totalDays = parseInt(businessDaysToAdd);

        while (daysAdded < totalDays) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
            if (!this.isDayExcluded(deliveryDate)) {
                daysAdded++;
            }
        }

        return deliveryDate.toLocaleDateString('en-US');
    }

    countdownToTime(targetTime) {
        const currentTime = new Date();
        let targetDate = new Date(currentTime);

        // Set the target time on today
        const [hours, minutes, seconds] = targetTime.split(':').map(Number);
        targetDate.setHours(hours, minutes, seconds || 0, 0);

        // If today is an excluded day or the cutoff has passed, find the next business day
        if (this.isDayExcluded(currentTime) || targetDate < currentTime) {
            const nextBizDay = this.getNextBusinessDay(currentTime);
            nextBizDay.setHours(hours, minutes, seconds || 0, 0);
            targetDate = nextBizDay;
        }

        const remainingTime = targetDate - currentTime;

        const h = Math.floor(remainingTime / (1000 * 60 * 60)),
            m = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours: h, minutes: m };
    }
}
customElements.define('delivery-time', DeliveryTime);